import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["block", "justified", "clsPrefix", "separated", "vertical", "className", "list"],
    _excluded2 = ["title", "onClick", "className"];

var _dec, _class;

import "core-js/modules/es6.array.map.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import classNames from 'classnames';
import Button from '../../wui-button/src';
import PropTypes from 'prop-types';
import { WebUI } from "../../wui-core/src/index.js";
import omit from 'omit.js';
var propTypes = {
  /**
   * 是否垂直排列
   */
  vertical: PropTypes.bool,

  /**
   * 是否对齐
   */
  justified: PropTypes.bool,

  /**
   * 垂直时是否为块状元素
   */
  block: PropTypes.bool,

  /**
   * 传入数组替代button
   */
  list: PropTypes.array,
  clsPrefix: PropTypes.string
};
var defaultProps = {
  block: false,
  justified: false,
  vertical: false,
  list: [],
  clsPrefix: "u-button-group"
};
var ButtonGroup = (_dec = WebUI({
  name: "button-group",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(ButtonGroup, _React$Component);

  var _super = _createSuper(ButtonGroup);

  function ButtonGroup(props, context) {
    var _this;

    _classCallCheck(this, ButtonGroup);

    _this = _super.call(this, props, context);

    _defineProperty(_assertThisInitialized(_this), "handleItemClick", function (key, onClick) {
      return function (e) {
        _this.setState({
          activeKey: key
        });

        onClick && onClick(e);
      };
    });

    _this.state = {
      activeKey: ''
    };
    return _this;
  }

  _createClass(ButtonGroup, [{
    key: "render",
    value: function render() {
      var _tbClass,
          _this2 = this;

      var _this$props = this.props,
          block = _this$props.block,
          justified = _this$props.justified,
          clsPrefix = _this$props.clsPrefix,
          separated = _this$props.separated,
          vertical = _this$props.vertical,
          className = _this$props.className,
          list = _this$props.list,
          others = _objectWithoutProperties(_this$props, _excluded);

      var tbClass = (_tbClass = {}, _defineProperty(_tbClass, "".concat(clsPrefix), vertical ? false : true), _defineProperty(_tbClass, "".concat(clsPrefix, "-block"), vertical ? block : false), _defineProperty(_tbClass, "".concat(clsPrefix, "-vertical"), vertical), _defineProperty(_tbClass, "".concat(clsPrefix, "-justified"), justified), _defineProperty(_tbClass, "".concat(clsPrefix, "-separated"), separated), _tbClass);

      if (list.length === 0) {
        return /*#__PURE__*/React.createElement("div", _extends({}, others, {
          className: classNames(tbClass, className)
        }), this.props.children);
      }

      return /*#__PURE__*/React.createElement("div", _extends({}, others, {
        className: classNames(tbClass, className)
      }), list.map(function (item) {
        var title = item.title,
            onClick = item.onClick,
            className = item.className,
            otherProps = _objectWithoutProperties(item, _excluded2);

        return /*#__PURE__*/React.createElement(Button, _extends({
          className: classNames(className, {
            'active': _this2.state.activeKey === item.key
          }),
          onClick: _this2.handleItemClick(item.key, onClick)
        }, omit(otherProps, ["isText"])), title);
      }));
    }
  }]);

  return ButtonGroup;
}(React.Component)) || _class);
ButtonGroup.propTypes = propTypes;
export default ButtonGroup;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-button-group/src/ButtonGroup.js